// extracted by mini-css-extract-plugin
module.exports = {"accordionV2":"ResponsiveAccordion_accordionV2__f_7wA","label":"ResponsiveAccordion_label__bpr7_","accordionMarker":"ResponsiveAccordion_accordionMarker__TanfJ"};